import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'bb-beneficiary-contact',
  templateUrl: 'beneficiary-contact.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BeneficiaryContactComponent {
  /**
   * Contact item
   */
  @Input()
  set contact(item: any & { accountName?: string }) {
    this._contact = item;
    if (item?.accounts[0]) {
      this.accountNumber = item.accounts[0].accountNumber || item.accounts[0].IBAN || '';
    }
  }
  get contact() {
    return this._contact;
  }

  @Input()
  displayBankName = false;

  private _contact!: any & { accountName?: string };

  accountNumber?: string;
}
